import { render, staticRenderFns } from "./studentsEditDataMedical.vue?vue&type=template&id=11857fad&scoped=true"
import script from "./studentsEditDataMedical.vue?vue&type=script&lang=js"
export * from "./studentsEditDataMedical.vue?vue&type=script&lang=js"
import style0 from "./studentsEditDataMedical.vue?vue&type=style&index=0&id=11857fad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11857fad",
  null
  
)

export default component.exports